(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  exports.Qbusers_Handler = (function(superClass) {
    extend(Qbusers_Handler, superClass);

    function Qbusers_Handler() {
      return Qbusers_Handler.__super__.constructor.apply(this, arguments);
    }

    Qbusers_Handler.prototype.init = function() {
      this.sidebar_open = false;
      this.layoutUrl = 'backend/portal/qbusers/';
      return this.createDialog();
    };

    Qbusers_Handler.prototype.afterLoadLayout = function() {
      var self;
      self = this;
      this.openDialog();
      this.dialog.find('.message_writer').message_writer();
      this.dialog.find('.sel_qb_users').select2({
        width: '500px',
        placeholder: 'Select...'
      });
      this.dialog.find('.sel_qb_users').bind('change', function() {
        var uid, val;
        uid = $(this).data('uid');
        val = $(this).val();
        return $.post('backend/portal/qbusers/save-match', {
          uid: uid,
          qbid: val
        }, function(response) {
          self.dialog.find('.message_writer').message_writer(response.status.type, response.status.msg);
          if (response.status.type === 'success') {
            return self.dialog.find('.message_writer').message_writer('hide');
          }
        });
      });
      return this.dialog.find('.btn-refresh').bind('click', (function(_this) {
        return function() {
          return _this.refresh();
        };
      })(this));
    };

    return Qbusers_Handler;

  })(FullPageHandler);

}).call(this);
